export type ContextWithQuery = {
    query: string
}

export type ContextWithTranslatedQuery = {
    translatedQuery?: string
}

